<template>
  <div class="chooseSearch">
    <div class="fl">
      <div
        v-for="(item,index) in chooseOpt.defaultDatas"
        :key="item.value"
        class="chooseBlock"
        :class="chooseIndex == index?'active':''"
        @click="chooseClick(item.value,index)"
      >{{item.text}}</div>
    </div>
    <div class="fr">
      <el-input placeholder="请输入标的名称" v-model="searchValue" clearable></el-input>
      <el-button type="primary" @click="searchClick" style="margin-left:8px;">搜索</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chooseOpt: {
      type: Object,
      default: function() {
        return {
          defaultVal: "0",
          defaultDatas: [
            {
              text: "所有",
              value: ""
            },
            {
              text: "一个月内",
              value: 1
            },
            {
              text: "三个月内",
              value: 3
            },
            {
              text: "半年内",
              value: 6
            }
          ]
        };
      }
    },
    searchInfo: {}
  },
  data() {
    return {
      chooseValue: this.chooseOpt.defaultVal,
      searchValue: "",
      chooseIndex: -1
    };
  },
  watch: {
    searchInfo:{
      handler(newVal, oldVal){
        this.chooseIndex = newVal.chooseIndex
        this.searchValue = newVal.name
      },
      deep: true
    }
  },
  methods: {
    chooseClick(val,index) {
      if(val){
        const date = new Date();
        date.setMonth(date.getMonth() - Number(val));
        val = date.getTime()
      }
      this.chooseValue = val;
      this.chooseIndex = index;
      this.commitForm({chooseValue:val,chooseIndex: index});
    },
    searchClick(){
      this.commitForm({
        chooseValue:this.chooseValue,
        searchValue:this.searchValue,
        chooseIndex: this.chooseIndex
      });

    },
    commitForm(prop) {
      this.$emit('handleQuery',{
        chooseValue:this.chooseValue,
        searchValue:this.searchValue,
        chooseIndex: this.chooseIndex
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.chooseSearch {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .fl {
    flex: 1;
    height: 100%;
    white-space: nowrap;
    .chooseBlock {
      font-size: 12px;
      text-align: center;
      margin: 0 6px;
      cursor: pointer;
      width: 64px;
      height: 24px;
      line-height: 24px;
      display: inline-block;
      border: 1px solid #ebecef;
      border-radius: 2px;
      color: #394259;
      &.active {
        color: #22C686;
        border: 1px solid #22C686;
      }
    }
  }
  .fr {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    max-width: 380px;
  }
}
</style>
